<template>
  <div id="content">
     <div class="nav_title">
      利源诚企服
    </div>
    <!-- <div class="nav_left">
      <img src="../assets/images/pc_top1.jpg" />
    </div> -->
    <div class="nav_middle">
      <div class="a_content">
        <div
          v-for="(item, index) in indexData"
          :key="index"
          class="a_all"
          :class="checks == index ? 'a1_all' : ''"
          @mouseover="mouseOver(index)"
          @mouseleave="leave(index)"
          @click="isCheck(index)"
        >
          <div :class="checks == index ? 'a_title1' : 'a_title3'">
            <router-link
              style="color: #ffffff; text-decoration: none"
              :to="item.myRoute"
              >{{ item.name }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="nav_right" @click="See('http://chengqifu.com/person.php')">
      <img src="../assets/images/pc_loginbtn.png" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["loginValue"],
  data() {
    return {
      date: "2022,6,7", //倒计时
      wxapplets: "/mf.png", //微信二维码
      myData: {},
      shows: false,
      userName: "匿名用户",
      token: "",
      checks: 1,
      isShow: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow9: false,
      isBg: "",
      indexData: [
        { name: "首页", myRoute: "/index" },
        {
          name: "关于",
          myRoute: "/about",
        },
        {
          name: "代账",
          myRoute: "/dz",
        },
        {
          name: "审计",
          myRoute: "/sj",
        },
        { name: "入驻", myRoute: "/rz" },
      ],
    };
  },
  activated() {
    this.checks = 0;
    this.isShow = false;
    this.isShow1 = false;
    this.isShow2 = false;
    this.isShow3 = false;
    this.isShow9 = false;
  },
  //倒计时计算属性
  computed: {
    stars: function () {
      return function (date) {
        var EndTime = new Date(date);
        var NowTime = new Date();
        var t = EndTime.getTime() - NowTime.getTime();
        var res =
          Math.floor(t / 1000 / 60 / 60 / 24) > 0
            ? Math.floor(t / 1000 / 60 / 60 / 24)
            : 0;
        return res;
      };
    },
  },
  methods: {
    See(e){
      window.location.href = e
    },
    //开通VIP
    myvip() {
      this.$router.push({ path: "/myVip" });
    },
    //鼠标移入显示二维码
    enters() {
      this.shows = true;
    },
    //鼠标移出影藏二维码
    leaveTo() {
      this.shows = false;
    },
    //鼠标移入
    mouseOver(e) {
      this.checks = e;
      if (this.checks == 2) {
        this.isShow = true;
      } else if (this.checks == 5) {
        this.isShow1 = true;
      } else if (this.checks == 3) {
        this.isShow2 = true;
      } else if (this.checks == 1) {
        this.isShow3 = true;
      } else if (this.checks == 8) {
        this.isShow9 = true;
      }
    },
    leave() {
      if (this.checks == 2) {
        this.isShow = false;
      } else if (this.checks == 5) {
        this.isShow1 = false;
      } else if (this.checks == 3) {
        this.isShow2 = false;
      } else if (this.checks == 1) {
        this.isShow3 = false;
      } else if (this.checks == 8) {
        this.isShow9 = false;
      }
    },
    //鼠标移入
    mouseOver2(e) {
      this.checks = e;
      if (this.checks == 5) {
        this.isShow1 = true;
      }
    },
    leave2() {
      if (this.checks == 5) {
        this.isShow1 = false;
      }
    },
    //鼠标移入
    mouseOver3(e) {
      this.checks = e;
      if (this.checks == 4) {
        this.isShow2 = true;
      }
    },
    leave3() {
      if (this.checks == 4) {
        this.isShow2 = false;
      }
    },
    //鼠标移入
    mouseOver6(e) {
      this.checks = e;
      if (this.checks == 3) {
        this.isShow3 = true;
      }
    },
    leave6() {
      if (this.checks == 3) {
        this.isShow3 = false;
      }
    },
    //鼠标移入个人中心
    mouseOver9(e) {
      this.checks = e;
      if (this.checks == 9) {
        this.isShow9 = true;
      }
    },
    leave9() {
      if (this.checks == 9) {
        this.isShow9 = false;
      }
    },
    mouseOver1(e) {
      this.isBg = e;
    },
    leave1() {
      this.isBg = "";
    },
    //选中时的状态
    isCheck(e) {
      this.checks = e;
    },
    //app下载页面
    download() {
      this.$router.push({ path: "/download/appDownload" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.router-link {
  text-decoration: none;
  color: #ffffff;
}
#content {
  .l_content {
    margin: auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafbfc;
    .l_content_mid {
      width: 1240px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;

      .l_all {
        display: flex;
        align-items: center;
        .l_title6 {
          font-size: 16px;
          font-weight: 400;
          color: #f94d28;
          margin-right: 20px;
        }
        .l_title7 {
          height: 33px;
          display: flex;
          align-items: center;
          font-size: 12px;
          font-weight: 400;
          color: #a2a2a3;
        }
        .l_title7 img {
          margin-right: 5px;
        }
        .l_title7 span {
          font-size: 15px;
          color: #4c4b4b;
          padding-left: 10px;
        }
        .l_title8 {
          margin-left: 42px;
          line-height: 35px;
          height: 35px;
          float: left;
          padding-left: 22px;
          font-size: 14px;
        }
        .l_title8 em {
          float: left;
          font-style: normal;
        }
        .l_title8 span {
          font-size: 24px;
          width: 60px;
          letter-spacing: 7px;
          padding-left: 4px;
          height: 26px;
          line-height: 26px;
          display: block;
          float: left;
          color: #f5413d;
          font-weight: bold;
          margin-left: 5px;
          margin-right: 5px;
          margin-top: 5px;
        }
      }
      .l_title1 {
        display: flex;
        align-items: center;
        position: relative;
        margin-right: 213px;
        .xiao_code {
          position: absolute;
          height: 120px;
          width: 120px;
          right: 50px;
          top: 40px;
          z-index: 9999;
        }
        .login {
          margin-left: 50px;
          width: 50px;
          height: 20px;
          background: #fea52d;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3px;
          font-size: 14px;
        }
        .login:hover {
          color: #f58235;
          background-color: #0000ee;
        }
        .icon-shuoming {
          color: #2bdf6a;
          font-size: 20px;
        }
        .icon-weixin1 {
          color: #69c028;
          font-size: 20px;
        }
        .icon-shouji1 {
          color: #1872e9;
          font-size: 20px;
        }
        .icon-tuandui {
          color: #f94d28;
          font-size: 20px;
        }
        .l_title2:hover {
          cursor: pointer;
          color: #f58235;
        }
        .l_title2 {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin-left: 2px;
          margin-right: 8px;
        }
      }
      .vip {
        width: 151px;
        height: 51px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
  .n_content {
    position: absolute;
    width: 135px;
    background-color: #f8f8f8;
    left: -33px;
    top: 38px;
    z-index: 999;
    .b_title1 {
      width: 135px;
      height: 40px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
    }
  }
  .w_content {
    position: absolute;
    width: 135px;
    background-color: #f8f8f8;
    left: -24px;
    top: 38px;
    z-index: 999;
    .b_title1 {
      width: 135px;
      height: 40px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
    }
  }
  .s_content {
    position: absolute;
    width: 135px;
    background-color: #f8f8f8;
    left: -25px;
    top: 38px;
    z-index: 999;
    .b_title1 {
      width: 135px;
      height: 40px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
    }
  }
  .k_content {
    position: absolute;
    width: 135px;
    background-color: #f8f8f8;
    right: -46px;
    top: 38px;
    z-index: 999;
    .b_title1 {
      width: 135px;
      height: 40px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
    }
  }
  .j_content {
    position: absolute;
    width: 151px;
    background-color: #ffffff;
    right: -46px;
    top: 38px;
    z-index: 999;
    .c_title1 {
      width: 151px;
      height: 40px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
      // border-bottom: 1px solid #F5F5F5;
    }
  }
  .a_content {
    width: 100%;
    height: 55px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    //
    .a1_all {
      padding: 0px 14px;
      box-sizing: border-box;
      position: relative;
      height: 55px;
      display: flex;
      justify-content: center;
      align-items: center;
      //background-color: #337CFF;
    }
    .a_all:hover {
      color: #337cff;
    }
    .a_all {
      padding: 0px 25px;
      box-sizing: border-box;
      position: relative;
      height: 55px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: #000;
      .iconfont {
        color: #ffffff;
        margin-left: 5px;
      }

      .a_title1 {
        font-size: 20px;
        font-weight: 600;
        position: relative;
      }
      .a_title1 a {
        color: #2c1fcd !important;
      }
      .a_title3 a {
        color: #000 !important;
      }
      .a_title3 {
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
      }

      .a_title2 {
        position: absolute;
        bottom: 0px;
        width: 33px;
        height: 4px;
        background: #ffffff;
        border-radius: 3px;
      }
    }
  }
}
.nav-link {
  display: inline-block;
}
.nav {
  width: 100%;
  height: 73rpx;
  background: #fff;
  position: relative;
}
.nav_title {
  z-index: 50000;
  position: absolute;
  top: 0;
  left: 100px;
  color:#2c1fcd;
  font-weight: 800;
  line-height: 55px;
  font-size: 25px;
}
.nav_left {
  z-index: 50000;
  position: absolute;
  top: 0;
  left: 373px;
  width: 220px;
  height: 111px;
}
.nav_left img {
  width: 220px;
  height: 111px;
}
.nav_middle {
  background: #fff;
  right: 200px;
  position: absolute;
}
.nav_right {
  position: absolute;
  top: 11px;
  right: 40px;
  width: 103px;
  height: 41px;
}
.nav .el-menu-item {
  padding: 0 35px !important;
  border: none !important;
}
.nav .el-menu-item a {
  font-size: 20px;
}
.nav .el-menu--horizontal > .el-menu-item.is-active {
  color: #2c1fcd !important;
  border: none !important;
}
#content{
    background: #fff;
    width: 100%;
    height: 55px;
}
</style>
